import { Component } from '@angular/core';
import { LogsComponent } from './logs/logs.component';
import { StatusComponent } from './status/status.component';

@Component({
  selector: 'app-dashboard-admin',
  imports: [LogsComponent, StatusComponent],
  templateUrl: './dashboard-admin.component.html',
  styles: ``,
})
export class DashboardAdminComponent {

}
